import React, { useState } from 'react';
import './PickModal.css';

const PickModal = ({ isOpen, onClose, userId, weekNum, onSuccess }) => {
  const [pick, setPick] = useState('');
  const [odds, setOdds] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const token = localStorage.getItem('token');

    try {
      // Submit Pick API
      const response = await fetch('https://ux97q9k5kb.execute-api.us-east-2.amazonaws.com/prod/picks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({weekNum, pick, odds})
     });

     console.log(response.status)

     if (response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return;
    }

     // Refreshes
      onSuccess();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Make Your Pick - Week {weekNum}</h3>
        <h4>{userId}</h4>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Pick:</label>
            <input
              type="text"
              value={pick}
              onChange={(e) => setPick(e.target.value)}
              placeholder="e.g., Patriots -3.5"
              required
            />
          </div>

          <div className="form-group">
            <label>Odds:</label>
            <input
              type="text"
              value={odds}
              onChange={(e) => setOdds(e.target.value)}
              placeholder="e.g., -110"
              required
            />
          </div>

          {error && <div className="error">{error}</div>}

          <div className="modal-buttons">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Pick'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PickModal;